"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawRotateIcon = exports.drawHorizontalLineIcon = exports.drawVerticalLineIcon = exports.drawCircleIcon = void 0;
// @ts-nocheck
var fabric_1 = require("fabric");
function drawCircleIcon(ctx, left, top, __styleOverride, fabricObject) {
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric_1.fabric.util.degreesToRadians(fabricObject.angle));
    ctx.beginPath();
    ctx.arc(0, 0, 6, 0, 2 * Math.PI);
    ctx.shadowColor = "#333333";
    ctx.shadowBlur = 3;
    ctx.fillStyle = "#ffffff";
    ctx.fill();
    ctx.restore();
}
exports.drawCircleIcon = drawCircleIcon;
function drawVerticalLineIcon(ctx, left, top, _styleOverride, fabricObject) {
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric_1.fabric.util.degreesToRadians(fabricObject.angle));
    drawRectRounded(ctx, -2, -14, 4, 18, 2);
    ctx.lineWidth = 4;
    ctx.strokeStyle = "#3782F7";
    ctx.stroke();
    ctx.fillStyle = "#ffffff";
    ctx.fill();
    ctx.restore();
}
exports.drawVerticalLineIcon = drawVerticalLineIcon;
function drawRectRounded(ctx, x, y, w, h, radius) {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.arcTo(x + w, y, x + w, y + h, radius);
    ctx.arcTo(x + w, y + h, x, y + h, radius);
    ctx.arcTo(x, y + h, x, y, radius);
    ctx.arcTo(x, y, x + w, y, radius);
    ctx.closePath();
}
function drawHorizontalLineIcon(ctx, left, top, _styleOverride, fabricObject) {
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric_1.fabric.util.degreesToRadians(fabricObject.angle));
    drawRectRounded(ctx, -14, -2, 18, 4, 2);
    ctx.lineWidth = 4;
    ctx.strokeStyle = "#3782F7";
    ctx.stroke();
    ctx.fillStyle = "#ffffff";
    ctx.fill();
    ctx.restore();
}
exports.drawHorizontalLineIcon = drawHorizontalLineIcon;
function drawRotateIcon(ctx, left, top, _styleOverride, _fabricObject) {
    var radius = 6;
    var lineWidth = radius / 3;
    var arrowWidth = radius / 2;
    var center = {
        x: left,
        y: top,
    };
    var arrow1 = {
        startAngle: 0 * Math.PI + 0.6,
        endAngle: 1.8 * Math.PI,
    };
    var arrow2 = {
        startAngle: (3 / 2) * Math.PI + 0.6,
        endAngle: (1 / 2) * Math.PI,
    };
    function draw(startAngle, endAngle) {
        ctx.beginPath();
        ctx.shadowBlur = 0;
        ctx.arc(center.x, center.y, radius, startAngle, endAngle);
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = "#3782F7";
        ctx.stroke();
        ctx.beginPath();
        var arrowTop = getPointOnCircle(center, radius, endAngle + 0.4);
        ctx.moveTo(arrowTop.x, arrowTop.y);
        var arrowLeft = getPointOnCircle(center, radius - arrowWidth, endAngle);
        ctx.lineTo(arrowLeft.x, arrowLeft.y);
        var arrowRight = getPointOnCircle(center, radius + arrowWidth, endAngle);
        ctx.lineTo(arrowRight.x, arrowRight.y);
        ctx.fillStyle = "#3782F7";
        ctx.closePath();
        ctx.fill();
    }
    function getPointOnCircle(center, radius, angle) {
        var pX = center.x + Math.cos(angle) * radius;
        var pY = center.y + Math.sin(angle) * radius;
        return { x: pX, y: pY };
    }
    ctx.save();
    ctx.translate(0, 0);
    ctx.beginPath();
    ctx.arc(center.x, center.y, radius + 5, 0, Math.PI * 2);
    ctx.fillStyle = "#ffffff";
    ctx.shadowBlur = 2;
    ctx.shadowColor = "black";
    ctx.fill();
    ctx.closePath();
    draw(arrow1.startAngle, arrow1.endAngle);
    // draw(arrow2.startAngle, arrow2.endAngle);
    ctx.restore();
}
exports.drawRotateIcon = drawRotateIcon;
//# sourceMappingURL=drawer.js.map